import { ExtractAtomicOperationFromDefinition } from "../../atomic-operations";
import { GridLayoutId, StaticGridLayoutId } from "../../idTypeBrands";
import { SemanticCap } from "../../semanticCaps.js";
import { createHexVersionAtomicOperationDefinition } from "../HexVersionAtomicOperationDefinition";

const CREATE_GRID_LAYOUT_TYPE = "CREATE_GRID_LAYOUT" as const;
export const CREATE_GRID_LAYOUT = createHexVersionAtomicOperationDefinition({
  type: CREATE_GRID_LAYOUT_TYPE,
  readAuth: {
    kind: "hasSemanticCap",
    cap: SemanticCap.VIEW_PROJECT_CONTENTS_FOR_LOGIC,
  },
  writeAuth: {
    kind: "and",
    and: [
      {
        kind: "idArgDoesNotExist",
        idArg: "gridLayoutId",
        idType: "GridLayout",
      },
      {
        kind: "hasSemanticCap",
        cap: SemanticCap.EDIT_PROJECT_CONTENTS,
      },
    ],
  },
  logSafe: ["gridLayoutId", "insertAt", "staticId"],
  conflictId: (op) => `${CREATE_GRID_LAYOUT_TYPE}-${op.payload.gridLayoutId}`,
  create: (args: {
    gridLayoutId: GridLayoutId;
    insertAt: string;
    name: string;
    staticId?: StaticGridLayoutId | null;
  }) => ({
    type: CREATE_GRID_LAYOUT_TYPE,
    payload: {
      ...args,
    },
  }),
});

export type CREATE_GRID_LAYOUT = ExtractAtomicOperationFromDefinition<
  typeof CREATE_GRID_LAYOUT
>;
